/* eslint-disable react/no-danger */
import React, { memo } from 'react';
import { messageFormat } from '@clubmed/utils';
import { pluralizeLabel } from 'Utils/label/labelUtils';
type Props = {
  dataTestId?: string;
  pluralLabel: string;
  resultsCount: number;
  singularLabel: string;
};
export const SearchResultsTitle = (props: Props) => {
  const { dataTestId, pluralLabel, resultsCount, singularLabel } = props;

  if (!pluralLabel || !singularLabel) {
    return null;
  }

  return (
    <p data-testid={dataTestId} className="text-20 font-semibold leading-tight">
      {resultsCount && resultsCount > 0 ? (
        <span
          dangerouslySetInnerHTML={{
            __html: messageFormat(pluralizeLabel(singularLabel, pluralLabel, resultsCount)).format({
              nbResults: resultsCount,
            }),
          }}
        />
      ) : null}
    </p>
  );
};
export default memo<Props>(SearchResultsTitle);
